import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { useMemo } from 'react'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { Colors, Shapes } from 'src/components/theme'
import { rgbaStrOpacity } from 'src/utils/colors'
import { formatVal } from 'src/utils/number-format'
import { LabelExtra } from 'src/views/subscriptions/table'
import type Stripe from 'stripe'

const PlanButton = styled(ButtonWithIcon)`
  flex: 1;
  flex-shrink: 0;
  flex-direction: column;
  display: flex;
  align-items: start;
  justify-content: flex-start;
  gap: ${Shapes.spacing[1] / 2}px;
  padding: ${Shapes.spacing[2]}px;
  border-width: 2px;
  border-color: ${(props) => (props.active ? Colors.blueDark : Colors.border)};
  background-color: ${(props) => (props.active ? rgbaStrOpacity(Colors.blueDark, 0.1) : 'transparent')};
  color: ${Colors.textDark};
  :hover {
    background-color: ${(props) => (props.active ? rgbaStrOpacity(Colors.blueDark, 0.1) : 'transparent')};
  }
`
const PlanButtonTitle = styled(Typography)``
const PlanButtonPrice = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Shapes.spacing[1]}px;
`
const PlanButtonChip = styled(LabelExtra)`
  margin-left: ${Shapes.spacing[1]}px;
`

type SubscriptionPlanButtonProps = {
  active: boolean
  price: Stripe.Price
  onClick: () => void
}
export const SubscriptionPlanButton = (props: SubscriptionPlanButtonProps) => {
  const { active, price, onClick } = props

  const monthlyPrice = useMemo(() => {
    if (!price.unit_amount) {
      return formatVal(0, 'currency-expanded')
    }
    if (price.recurring?.interval === 'year') {
      return formatVal(price.unit_amount / 12 / 100, 'currency-expanded')
    }
    return formatVal(price.unit_amount / 100, 'currency-expanded')
  }, [price])

  return (
    <PlanButton key={price.id} active={active} onClick={onClick}>
      <PlanButtonTitle variant="text1m">
        Billed {price.recurring?.interval === 'year' ? 'Annually' : 'Monthly'}
      </PlanButtonTitle>
      {price.unit_amount && (
        <PlanButtonPrice>
          <Typography variant="title2">{monthlyPrice}</Typography>
          {price.recurring?.interval && (
            <Typography variant="textmdm" color={Colors.textMedium}>
              / month
            </Typography>
          )}
          {price.recurring?.interval === 'year' && <PlanButtonChip color={'warning'} label="Save 15%" />}
        </PlanButtonPrice>
      )}
    </PlanButton>
  )
}
